
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitogoacabs() {



    const cardData =
    {
        keyword: 'Mumbai to Pune Cabs',
        heading: 'S9 Travels:  Mumbai to Pune Cabs',
        headingDescription: 'S9 Travels offers dependable and comfortable Mumbai to Pune cab services, tailored for business travelers, family trips, and personal journeys. Covering a distance of around 150 kilometers, the trip typically takes 3 to 3.5 hours via expressway. With a fleet of well-maintained sedans, SUVs, and luxury vehicles, and professional drivers, we ensure a safe, smooth, and timely ride.',

        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is a historic fortification in Pune, built in 1732. It was the seat of the Peshwas of the Maratha Empire. The fort is known for its majestic architecture, intricate carvings, and historical significance."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Aga Khan Palace is a historic landmark that played a crucial role in India’s freedom struggle. It served as a prison for Mahatma Gandhi and his associates during the Quit India Movement. The palace is now a museum displaying various artifacts related to Gandhi’s life."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Perched atop a hill, Sinhagad Fort is a historic site that offers breathtaking views of the surrounding landscape. It is known for its significance in Maratha history and is a popular trekking destination for adventure enthusiasts."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "This famous temple is dedicated to Lord Ganesha and attracts thousands of devotees every year. Known for its beautiful idol adorned with gold and jewelry, the temple is a must-visit for spiritual seekers and tourists alike."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An ancient rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple dates back to the 8th century. It is a significant architectural and historical site, offering a serene and spiritual experience."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This fascinating museum houses an extensive collection of artifacts, sculptures, musical instruments, and everyday objects from Indian history. It provides a glimpse into India’s rich cultural heritage."
    },
    {
      "title": "Vetal Tekdi",
      "description": "Vetal Tekdi is a popular hill in Pune known for its scenic beauty and trekking trails. It is an ideal spot for nature lovers and fitness enthusiasts looking for an early morning hike or a peaceful escape from the city."
    },
    {
      "title": "Pashan Lake",
      "description": "Pashan Lake is a tranquil artificial lake that serves as a great spot for birdwatching and leisurely walks. It’s a perfect place to unwind amidst nature and enjoy the peaceful surroundings."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-renowned spiritual retreat offering meditation programs, wellness therapies, and a serene environment for self-discovery."
    },
    {
      "title": "FC Road and JM Road",
      "description": "Fergusson College Road (FC Road) and Jangali Maharaj Road (JM Road) are bustling streets famous for their shopping, street food, and lively ambiance. From trendy clothes to delicious street snacks, these roads are a paradise for youngsters and shopaholics."
    }
],

"services": [
  {
    "name": "Mumbai to Pune Innova Cab",
    "description": "Book a reliable Mumbai to Pune Innova cab with S9 Travels for a comfortable and spacious journey. Ideal for airport pickups, business trips, or family travel — our Innova offers smooth rides and ample luggage space."
  },
  {
    "name": "Mumbai to Pune One-Way Innova",
    "description": "Enjoy a hassle-free one-way ride from Mumbai to Pune in a premium Innova cab. Perfect for travelers looking for convenience, space, and affordability on a single-direction trip."
  },
  {
    "name": "Private Innova Cab from Pune to Mumbai Airport",
    "description": "Travel privately from Pune to Mumbai Airport in a clean, well-maintained Innova. Our professional drivers ensure a timely drop, with return options available via our Mumbai to Pune cab services."
  },
  {
    "name": "Luxury Innova for Mumbai to Pune Travel",
    "description": "Experience luxury with our Innova Crysta Mumbai to Pune cab service. With plush seating, air-conditioning, and extra legroom, it’s perfect for corporate and premium travelers."
  },
  {
    "name": "Affordable Innova Cab from Pune to Mumbai Airport",
    "description": "Looking for budget-friendly travel? Book our affordable Innova taxi from Pune to Mumbai Airport. Spacious, comfortable, and priced right — with return trip options to Pune also available."
  },
  {
    "name": "Airport Pickup: Mumbai to Pune Innova Cab",
    "description": "Just landed at Mumbai Airport? Our Innova cabs are ready for a smooth transfer to Pune. Get door-to-door pickup, reliable timing, and maximum comfort with S9 Travels."
  },
  {
    "name": "Group Travel in Innova: Mumbai to Pune",
    "description": "Planning a group journey from Mumbai to Pune? Our 6-7 seater Innova taxis offer ample space for your companions and luggage, making group travel stress-free and enjoyable."
  },
  {
    "name": "Round Trip Innova Cab: Pune to Mumbai Airport",
    "description": "Book a round-trip Innova cab with S9 Travels from Pune to Mumbai Airport and back. Get flexible scheduling, reliable pickup, and comfort on both legs of your journey."
  },
  {
    "name": "Pune to Mumbai Airport Innova Taxi Booking",
    "description": "Easily book an Innova taxi from Pune to Mumbai Airport with S9 Travels. Round-trip and one-way services available with experienced drivers and smooth highway rides guaranteed."
  }
],
  "tableData": [
    ["Mumbai to Pune Innova Cab", "Mumbai to Pune One-Way Innova"],
    ["Private Innova Cab from Pune to Mumbai Airport", "Luxury Innova for Mumbai Airport"],
    ["Affordable Pune to Mumbai Airport Innova", "Mumbai to Pune Innova Cab"],
    ["Group Travel to Mumbai Airport by Innova", "Pune to Mumbai Airport Round Trip Innova"],
    ["Book Pune to Mumbai Airport Innova Cab", "Mumbai to Pune Innova Cab"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand how crucial it is to reach your destination on time. Whether you're coming from Mumbai or going to Pune, we ensure prompt pickups from your location and a smooth drive to your destination. Our drivers are punctual and committed to ensuring a timely and comfortable journey."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova is the ideal choice for long journeys like Mumbai to Pune. With comfortable seating, air conditioning, and ample space for luggage, our Innova cabs provide a relaxing and stress-free travel experience. Whether traveling solo or with family or friends, you'll enjoy a pleasant ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced and familiar with the best routes from Mumbai to Pune. They are punctual, courteous, and knowledgeable, ensuring a smooth and hassle-free journey. Your comfort and safety are our priorities, so you can enjoy a stress-free trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Mumbai to Pune Innova booking. You'll receive a clear breakdown of all costs before confirming your booking, with no hidden charges, making it easy to plan your travel without surprises."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Safety is our top priority. Our Toyota Innova vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. We ensure you have a secure and comfortable ride throughout your journey from Mumbai to Pune."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels is available 24/7, whether you're traveling from Mumbai to Pune in the early morning or late evening. Our customer service team is available around the clock to assist with your booking and ensure your ride is ready when you need it."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Mumbai to Pune Innova cab with S9 Travels is simple and convenient. You can book online through our website or mobile app, or contact our customer service team for personalized assistance in booking your cab."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "If you have specific requirements or need additional services during your journey, we offer customized travel packages. Whether you need a direct drop-off or a break along the way, we’ll tailor the trip to fit your needs."
  }
]









    }



    const faqData = [
        [
          {
            question: 'How can I book a cab from Mumbai to Pune with S9 Travels?',
            answer: 'Booking a cab for your Mumbai to Pune trip is easy! You can book online through our website or mobile app, or contact our customer service team for assistance.'
          },
          {
            question: 'What types of cabs are available for Mumbai to Pune travel?',
            answer: 'We offer a variety of cabs, including the spacious Toyota Innova, which is perfect for families, groups, and travelers with a lot of luggage.'
          },
          {
            question: 'Are the drivers experienced for the Mumbai to Pune route?',
            answer: 'Yes, our drivers are highly experienced and knowledgeable about the best routes between Mumbai and Pune, ensuring a comfortable and timely journey.'
          },
          {
            question: 'What payment options are available for booking a cab from Mumbai to Pune?',
            answer: 'We accept various payment methods, including cash, credit/debit cards, and secure online payments through our mobile app.'
          },
          {
            question: 'Can I book a round trip from Mumbai to Pune?',
            answer: 'Yes, we offer round-trip bookings. Just provide your return details, and we’ll arrange for a smooth and comfortable ride back from Pune to Mumbai.'
          },
          {
            question: 'Are there any extra charges for detours or waiting time during the trip?',
            answer: 'Any extra charges, including for waiting time or detours, will be communicated to you clearly before the trip, ensuring full transparency.'
          },
          {
            question: 'Can I make additional stops on the way from Mumbai to Pune?',
            answer: 'Yes, you can request additional stops. Simply let us know during the booking process, and we’ll accommodate your requests.'
          },
          {
            question: 'What is the luggage allowance for a cab on the Mumbai to Pune trip?',
            answer: 'The Toyota Innova has plenty of space for standard luggage. If you have more luggage or special requirements, please inform us at the time of booking.'
          },
          {
            question: 'Does S9 Travels provide corporate travel services for the Mumbai to Pune route?',
            answer: 'Yes, we offer corporate travel services for business trips from Mumbai to Pune, with professional drivers and comfortable vehicles.'
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai to Pune cab booking?',
            answer: 'S9 Travels offers reliable, safe, and comfortable rides. With well-maintained vehicles, professional drivers, and excellent customer service, we guarantee a smooth journey from Mumbai to Pune.'
          }
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Rajesh Mehta',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I recently booked a ride from Mumbai to Pune with S9 Travels, and the service was impeccable. The driver was on time, the vehicle was clean, and the ride was smooth and comfortable. Highly recommend!”'
        },
        {
          name: 'Mrs. Sunita Reddy',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I traveled from Mumbai to Pune with my family, and the experience with S9 Travels was fantastic. The car was spacious, the driver was courteous, and we had a safe and comfortable journey. I will definitely book again!”'
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
      
// const productSchema = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Mumbai to Pune Cab Service - S9 Travels",
//   "image": "https://s9travels.com/assets/images/mumbai-to-pune-cab.jpg",
//   "description": "Book a reliable and comfortable Mumbai to Pune cab with S9 Travels. Choose from hatchbacks, sedans, SUVs, and luxury vehicles for one-way or round-trip travel. Safe rides, professional drivers, and affordable prices guaranteed.",
//   "brand": {
//     "@type": "Organization",
//     "name": "S9 Travels"
//   },
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.9",
//     "ratingCount": "5267"
//   },
//   "offers": {
//     "@type": "Offer",
//     "priceCurrency": "INR",
//     "price": "1499",
//     "availability": "https://schema.org/InStock",
//     "url": "https://s9travels.com/mumbai-to-pune-cabs"
//   }
// };



 const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Mumbai to Pune Cab Service – S9 Travels",
    "image": "https://s9travels.com/assets/images/mumbai-to-pune-cab.jpg",
    "description":
      "Book Mumbai to Pune cab service from ₹1499 with S9 Travels. Enjoy one-way, round-trip, and airport transfer cabs in Hatchback, Sedan, SUV, and Innova Crysta. Professional drivers, clean AC cars, instant confirmation, and 24x7 customer support.",
    "brand": {
      "@type": "Brand",
      "name": "S9 Travels"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.9",
      "ratingCount": "6742"
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "1499",
      "availability": "https://schema.org/InStock",
      "url": "https://s9travels.com/mumbai-to-pune-cabs"
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is the fare for Mumbai to Pune cab?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "S9 Travels offers Mumbai to Pune cab fares starting from ₹1499 for Hatchback, ₹1999 for Sedan, and ₹2499 for SUV or Innova Crysta. Affordable pricing with no hidden charges and 24x7 support."
        }
      },
      {
        "@type": "Question",
        "name": "Does S9 Travels provide one-way taxi from Mumbai to Pune?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Yes, S9 Travels provides both one-way and round-trip Mumbai to Pune cab services. Enjoy professional drivers, clean AC cars, and instant online booking for all cab categories."
        }
      },
      {
        "@type": "Question",
        "name": "Is airport pickup and drop service available?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Yes, S9 Travels offers Mumbai Airport to Pune and Pune to Mumbai Airport cabs for both domestic and international terminals. Fixed-rate pricing, on-time pickups, and professional chauffeurs."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "S9 Travels",
    "image": "https://s9travels.com/assets/images/logo.png",
    "url": "https://s9travels.com/",
    "telephone": "+91 7090759555",
    "priceRange": "₹₹",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Wakad Road, Pimpri-Chinchwad",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "postalCode": "411057",
      "addressCountry": "IN"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "ratingCount": "6742"
    },
    "openingHours": "Mo-Su 00:00-23:59",
    "areaServed": "Mumbai, Pune, Navi Mumbai, Thane, Pimpri Chinchwad"
  };


      
      
      


    return (
        <div>


   <Helmet>
      {/* ✅ Title */}
      <title>
        Mumbai to Pune Cab Service from ₹1499 | 24x7 Taxi, Airport Drop & Outstation | S9 Travels
      </title>

      {/* ✅ Meta Description */}
      <meta
        name="description"
        content="Book Mumbai to Pune cabs from ₹1499 with S9 Travels – your trusted taxi partner for airport transfers, one-way trips, and outstation travel. Choose Hatchback, Sedan, SUV & Innova Crysta with professional drivers, 24x7 support, and on-time service."
      />

      {/* ✅ Meta Keywords */}
      <meta
        name="keywords"
        content="Mumbai to Pune Cabs, Mumbai to Pune Taxi, One Way Cab Mumbai to Pune, Round Trip Taxi Mumbai to Pune, Mumbai to Pune Airport Taxi, Mumbai to Pune Innova Crysta, Sedan SUV Cab Mumbai Pune, Online Cab Booking Mumbai to Pune, Luxury Taxi Mumbai Pune, Affordable Mumbai to Pune Cab Service"
      />

      {/* ✅ Canonical URL */}
      <link rel="canonical" href="https://s9travels.com/mumbai-to-pune-cabs" />

      {/* ✅ Product Schema */}
      <script type="application/ld+json">
        {JSON.stringify(productSchema)}
      </script>

      {/* ✅ FAQ Schema */}
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>

      {/* ✅ LocalBusiness Schema */}
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>

      {/* ✅ OG (Open Graph) Tags for Social Sharing */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Mumbai to Pune Cab Service from ₹1499 | S9 Travels" />
      <meta
        property="og:description"
        content="Hire Mumbai to Pune taxi with S9 Travels at affordable prices. 24x7 service, AC cars, and instant online booking."
      />
      <meta property="og:image" content="https://s9travels.com/assets/images/mumbai-to-pune-cab.jpg" />
      <meta property="og:url" content="https://s9travels.com/mumbai-to-pune-cabs" />
      <meta property="og:site_name" content="S9 Travels" />

      {/* ✅ Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Mumbai to Pune Cab Service from ₹1499 | S9 Travels" />
      <meta
        name="twitter:description"
        content="Book one-way or round-trip Mumbai to Pune cab from ₹1499 with S9 Travels. 24x7 support, AC cars, and professional drivers."
      />
      <meta name="twitter:image" content="https://s9travels.com/assets/images/mumbai-to-pune-cab.jpg" />
    </Helmet>

    
 {/* <Helmet>
  <title>Mumbai to Pune Cabs | One Way & Round Trip Taxi Booking - S9 Travels</title>
  
  <meta 
    name="description" 
    content="Book Mumbai to Pune cabs online at best prices with S9 Travels. One-way, round-trip, and luxury cab options available. Safe, comfortable, and reliable taxi service with professional drivers. 24/7 support and instant booking." 
  />

  <meta 
    name="keywords" 
    content="Mumbai to Pune Cabs, Mumbai to Pune Taxi, One Way Cab Mumbai to Pune, Round Trip Taxi Mumbai to Pune, Mumbai Pune Cab Booking, Online Taxi from Mumbai to Pune, AC Cabs Mumbai to Pune, Luxury Car Hire Mumbai to Pune, Affordable Taxi Mumbai Pune, SUV Sedan Hatchback Cab from Mumbai to Pune" 
  />

  <link rel="canonical" href="https://s9travels.com/mumbai-to-pune-cabs" />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet> 

//showing by this code on 8:3
*/}


      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/87.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitogoacabs;